import { merge } from 'ramda';
import { EXCEL_SUCCESS, EXCEL_FAIL, EXCEL_REQUEST } from 'src/store/actions/excelActions';

const initialState = {
  fetching: false,
  errors: []
};

const excelReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXCEL_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case EXCEL_SUCCESS:
      return merge(state, { fetching: false, errors: [] });
    case EXCEL_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    default:
      return state;
  }
};

export default excelReducer;
